module.exports = __webpack_public_path__ + "img/Support-skill-500.54efb9b2.png";